/** Deutsche Anzeige-Labels für die Enums (Backend: models/enums.py). */

import type { Prioritaet, ReportStatus, ReportTyp } from "@/types"

/** Datum zweistellig (07.07.2026), wie im Design-Handoff. */
export function datumKurz(iso: string): string {
  return new Date(iso).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
}

/** Datum mit Uhrzeit, z. B. „06.10.2026, 14:32" */
export function datumZeit(iso: string): string {
  return new Date(iso).toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export const STATUS_LABEL: Record<ReportStatus, string> = {
  entwurf: "Entwurf",
  neu: "Neu",
  gesichtet: "Gesichtet",
  in_umsetzung: "In Umsetzung",
  erledigt: "Erledigt",
  abgelehnt: "Abgelehnt",
  verworfen: "Verworfen",
}

export const STATUS_FARBE: Record<ReportStatus, string> = {
  entwurf: "bg-muted text-muted-foreground",
  neu: "bg-primary/10 text-primary",
  gesichtet: "bg-warning/10 text-warning",
  in_umsetzung: "bg-success/10 text-success",
  erledigt: "bg-success/10 text-success",
  abgelehnt: "bg-destructive/10 text-destructive",
  verworfen: "bg-destructive/10 text-destructive",
}

/** Farbiger Status-Punkt am Zeilenanfang der Übersichts-Karten. */
export const STATUS_PUNKT: Record<ReportStatus, string> = {
  entwurf: "bg-muted-foreground/40",
  neu: "bg-primary",
  gesichtet: "bg-warning",
  in_umsetzung: "bg-success",
  erledigt: "bg-success",
  abgelehnt: "bg-destructive",
  verworfen: "bg-muted-foreground/40",
}

/** Wer ist am Zug (#101) — Zusatz zum Status, als kombinierter Text. */
export const ZUG_LABEL = {
  dev: "wartet auf DEV",
  melder: "wartet auf Melder",
} as const

/** Status samt Zug-Zusatz: „In Umsetzung · wartet auf Melder". */
export function statusMitZug(r: { status: ReportStatus; zug?: "dev" | "melder" | null }): string {
  return r.zug ? `${STATUS_LABEL[r.status]} · ${ZUG_LABEL[r.zug]}` : STATUS_LABEL[r.status]
}

export const TYP_LABEL: Record<ReportTyp, string> = {
  fehler: "Fehler",
  aenderungswunsch: "Änderungswunsch",
}

export const PRIO_LABEL: Record<Prioritaet, string> = {
  niedrig: "Niedrig",
  mittel: "Mittel",
  hoch: "Hoch",
}

/** Prio-Badge: nur „Hoch“ sticht farblich heraus (Design-Handoff Screen 02). */
export const PRIO_BADGE: Record<Prioritaet, string> = {
  niedrig: "bg-secondary text-muted-foreground",
  mittel: "bg-secondary text-muted-foreground",
  hoch: "bg-warning/10 text-warning",
}
